/* @flow */

export const MapProviders = {
  HERE_MAPS: 'HERE_MAPS',
};
